import { isRejectedWithValue, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { getTranslateValue } from 'hooks';
import { toast } from 'react-toastify';
import { selectLabelsMap } from 'store/labels';
import { parseErrorData } from 'utils/service';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = parseErrorData(action.error);

    const message = getTranslateValue(selectLabelsMap(api.getState()), error.message);

    toast.error(message);
  }

  return next(action);
};
